import { QueryClient } from "@tanstack/react-query";

// Shared QueryClient instance so non-React modules (e.g. Mapbox custom
// controls) can read/invalidate cached queries without threading it through
// component props.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes - increased for better caching
      gcTime: 30 * 60 * 1000, // 30 minutes - keep data in cache longer
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true, // Refetch when internet reconnects
    },
    mutations: {
      retry: 1,
    },
  },
});
